<template>
    <div v-if="social=='facebook'" :class="styles" class=" bg-red-50 rounded-full -bottom-1 -right-2">
        <FacebookIcon/>
    </div>
    <div  v-else :class="styles" class="bg-pink-500  rounded-full -bottom-1 -right-2 flex justify-center items-center">
        <InstagramIcon/>
    </div>
</template>

<script>
import FacebookIcon from '@/components/svg/FacebookIcon';
import InstagramIcon from '@/components/svg/InstagramIcon';
export default {
    name:"SocialMediaLogo",
    props: {
        social: {
            type: String,
            required:true
        },

        styles: {
            type: String,
            default:'absolute w-6 h-6'
        },
    },

    components: {
        FacebookIcon,
        InstagramIcon
    },
}
</script>